import * as THREE from 'three';
import { camera } from './scene';
import { S } from './state';
import { $, fmt$ } from './util';

export function addDollars(v, at?, big?){
  const gain = Math.round(v * S.mult); S.dollars += gain; addSurge(100 * gain / Math.max(S.totalValue*0.05, 1));
  if (at) popup(fmt$(gain) + (S.mult>1.01 ? ` ×${S.mult.toFixed(1)}` : ''), at, big);
}
export function chainHit(){
  S.chain++; S.chainT = 3; S.mult = Math.min(3, 1 + (S.chain-1)*0.25); S.bestChain = Math.max(S.bestChain||1, S.mult);
  if (S.chain >= 2){ $('#combo').innerHTML = `×${S.mult.toFixed(2)}<small>${S.chain} chain</small>`; $('#combo').classList.add('on'); }
}
export function updateChain(dt){ if (S.chainT > 0){ S.chainT -= dt; if (S.chainT <= 0){ S.chain = 0; S.mult = 1; $('#combo').classList.remove('on'); } } }
export const _proj = new THREE.Vector3();
export function popup(text, worldPos, big?){
  _proj.copy(worldPos).project(camera); if (_proj.z > 1) return;
  const d = document.createElement('div'); d.textContent = text; if (big) d.className = 'big';
  d.style.left = ((_proj.x+1)/2*innerWidth)+'px'; d.style.top = ((1-_proj.y)/2*innerHeight)+'px';
  $('#pops').appendChild(d); setTimeout(()=>d.remove(), 1400);
}

export function addSurge(v){}
